import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';

export const useNoParcelsCopy = () => {
  const { t, isLoggedIn } = useGlobalState();
  const { getEnglishOnlyText: getAnonymousEnglishOnlyText, isReady: isAnonymousReady } =
    useStatsigLayer('track_my_parcel_copy_layer');
  const { getEnglishOnlyText: getSignedInEnglishOnlyText, isReady: isSignedInReady } = useStatsigLayer(
    'track_my_parcel_signed_in_layer',
  );

  const fallback = {
    noParcelsAdded: t(MasterTranslation.NoParcelsAdded),
    noParcelsFound: t(MasterTranslation.NoParcelsFound),
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const getEnglishOnlyText = isLoggedIn ? getSignedInEnglishOnlyText : getAnonymousEnglishOnlyText;

  return {
    noParcelsAdded: getEnglishOnlyText('no_parcels_added', fallback.noParcelsAdded),
    noParcelsFound: getEnglishOnlyText('no_parcels_found', fallback.noParcelsFound),
  };
};
